'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.devicecert.add', [])
  .controller('DeviceCertAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/devicecert/add/index.js